import { Card, Typography } from 'antd';
import React from 'react';
import { Grid } from 'antd';


const { useBreakpoint } = Grid;
const { Text } = Typography;

const DashboardCard = ({
  title,
  value,
  icon,
  status = 'default',
}) => {
  const screens = useBreakpoint();
  const hideIcon = !screens.md;

  const statusMapping = {
    success: {
      bg: 'linear-gradient(135deg, rgba(34,197,94,0.14), rgba(34,197,94,0.04))',
      iconBg: 'rgba(34,197,94,0.12)',
      color: '#16a34a',
    },
    pending: {
      bg: 'linear-gradient(135deg, rgba(37,99,235,0.14), rgba(37,99,235,0.04))',
      iconBg: 'rgba(37,99,235,0.12)',
      color: '#2563eb',
    },
    danger: {
      bg: 'linear-gradient(135deg, rgba(239,68,68,0.14), rgba(239,68,68,0.04))',
      iconBg: 'rgba(239,68,68,0.12)',
      color: '#dc2626',
    },
    warning: {
      bg: 'linear-gradient(135deg, rgba(245,158,11,0.14), rgba(245,158,11,0.04))',
      iconBg: 'rgba(245,158,11,0.12)',
      color: '#d97706',
    },
    scheduled: {
      bg: 'linear-gradient(135deg, rgba(14,165,233,0.14), rgba(14,165,233,0.04))',
      iconBg: 'rgba(14,165,233,0.12)',
      color: '#0284c7',
    },
    unassigned: {
      bg: 'linear-gradient(135deg, rgba(79,70,229,0.14), rgba(79,70,229,0.04))',
      iconBg: 'rgba(79,70,229,0.12)',
      color: '#4f46e5',
    },
    default: {
      bg: 'linear-gradient(135deg, rgba(148,163,184,0.14), rgba(148,163,184,0.04))',
      iconBg: 'rgba(148,163,184,0.12)',
      color: '#64748b',
    },
  };

  const theme = statusMapping[status] || statusMapping.default;

  return (
    <Card
      bordered={false}
      style={{
        background: theme.bg,
        borderRadius: 18,
        overflow: 'hidden',
        boxShadow: '0 6px 18px rgba(0,0,0,0.04)',
        transition: 'all 0.25s ease',
      }}
      styles={{
        body: {
          padding: 18
        }
      }}
      className="kpi-card"
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>

        {/* LEFT */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

          <Text
            strong
            style={{
              fontSize: 13,
              color: theme.color,
              letterSpacing: 0.3,
              textTransform: 'uppercase',
            }}
          >
            {title}
          </Text>

          <div style={{
            fontSize: 26,
            fontWeight: 750,
            lineHeight: 1.1,
            color: theme.color,
          }}>
            {value}
          </div>

        </div>

        {/* ICON BADGE */}
        {icon && !hideIcon && <div
          style={{
            width: 46,
            height: 46,
            borderRadius: 14,
            background: theme.iconBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.color,
            flexShrink: 0,
            boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.4)',
          }}
        >
          {icon}
        </div>}
      </div>
    </Card>
  );
};

export default DashboardCard;